import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneB1: any,
    sceneB2: any,
    sceneB3: any,
    sceneB4: any = null;
export default function B() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const [textEnter, setTextEnter] = useState(false);
    const { t } = useLang('smart_home_panel_2.launch.detail');

    const textLists: any[] = [
        {
            title: 'secB_list1_title',
            desc: 'secB_list1_desc',
        },
        {
            title: 'secB_list2_title',
            desc: 'secB_list2_desc',
        },
        {
            title: 'secB_list3_title',
            desc: 'secB_list3_desc',
        },
        locale === 'us' && {
            title: 'secB_list4_title',
            desc: 'secB_list4_desc',
            link: 'secB_list4_link',
            href: 'https://us.ecoflow.com/products/installation-service',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneB1) AniContainer.removeScene(sceneB1);
                // if (window?.innerWidth < 1024) {
                //     sceneB1 = AniContainer.create({
                //         syncFromTo: [['.shp2-detail-B .img-box', { scale: 1 }, { scale: 0.7 }]],
                //         triggerElement: '.shp2-detail-B',
                //         triggerHook: 1,
                //         offset: '100%',
                //         duration: '100%',
                //     });
                // }
                if (window?.innerWidth > 1024) {
                    sceneB2 = AniContainer.create({
                        asyncFromTo: [
                            [
                                '.shp2-detail-B .img-box',
                                { scale: 1, x: 0 },
                                {
                                    scale: window?.innerWidth >= 1440 ? 0.75 : window?.innerWidth < 768 ? 0.7 : 0.7,
                                    x: window?.innerWidth >= 1440 ? -160 : window?.innerWidth < 768 ? 0 : -80,
                                },
                                0.45,
                            ],
                            ['.shp2-detail-B .text-lists', { y: window?.innerHeight }, { y: 0 }, 0.5],
                        ],
                        asyncTimeLine: [0.1, 0.05],
                        triggerElement: '.shp2-detail-B',
                        triggerHook: 1,
                        offset: window?.innerWidth <= 1024 ? '10%' : '100%',
                        duration: window?.innerWidth <= 1024 ? '80%' : '100%',
                    });
                } else {
                    sceneB3 = AniContainer.create({
                        asyncFromTo: [['.shp2-detail-B .img-box', { opacity: 0 }, { opacity: 1 }]],
                        triggerElement: '.shp2-detail-B',
                        triggerHook: 1,
                        offset: 50,
                        duration: '60%', //window.innerHeight / 2,
                    });
                    sceneB4 = AniContainer.create({
                        triggerElement: '.shp2-detail-B .text-box',
                        triggerHook: 1,
                        offset: 200,
                        duration: 200, //window.innerHeight * 2,
                        onEnter: () => {
                            setTextEnter(true);
                        },
                        //onLeave: () => setTextEnter(false),
                    });
                }
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneB1) AniContainer.removeScene(sceneB1);
                if (sceneB2) AniContainer.removeScene(sceneB2);
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-B shp2-detail-section ${css['shp2-detail-B']}`}>
            <div className="sticky-box">
                <div className="content">
                    <div className="img-box">
                        <EFPicture src={'/responsive/picture/smart-home-panel-2/launch/2.png'} alt={t('secB_list1_title')} />
                    </div>
                    <div className={`text-box${textEnter ? ' textEnter' : ''}`}>
                        <ul className="text-lists">
                            {textLists?.map((list: any, k: number) => (
                                <li className={`text-list list-${k + 1}`} key={k}>
                                    <p className="list-title">{t(list?.title)}</p>
                                    <p className="list-desc">
                                        {t.rich(list?.desc, {
                                            w: (text: string) => <span className="white">{text}</span>,
                                        })}
                                    </p>
                                    {list.link && (
                                        <a href={list.href} target="_blank" rel="noreferrer">
                                            <p className="list-link">{t(list?.link)}</p>
                                        </a>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
